import { NaniumObject, Type } from "nanium/objects";
import { NaniumBuffer } from "nanium/interfaces/naniumBuffer";

export class VideoFile extends NaniumObject<VideoFile> {
  @Type(String) id?: string;
  @Type(String) dateCreated?: Date;
  @Type(Number) size?: number;
  @Type(String) gridFsFileId?: string;

  // this is not stored inside the db
  @Type(NaniumBuffer) video?: NaniumBuffer;
}
